var labels = {
  general: {
    message_title: {
      es: 'Mensaje',
      en: 'Message'
    },
    confirm: {
      es: 'Confirmación',
      en: 'Confirmation'
    },
    confirm_yes: {
      es: 'Si',
      en: 'Yes'
    },
    confirm_back: {
      es: 'Salir',
      en: 'Go out'
    },
    confirm_download: {
      es: 'La descarga del archivo se completó correctamente',
      en: 'The file download was completed successfully'
    },
    confirm_save_message: {
      es: 'Se guardó correctamente',
      en: 'Saved successfully'
    },
    confirm_save_title: {
      es: 'Éxito',
      en: 'Success'
    },
    confirm_delete_message: {
      es: 'Se eliminó el registro',
      en: 'The record was deleted'
    },
    error_proccessing: {
      es: 'Hubo un error al procesar la información',
      en: 'There was an error processing the information'
    },
    error_title: {
      es: 'Error',
      en: 'Error'
    },
    filter_required: {
      es: 'Debe completar al menos uno de los campos del filtro',
      en: 'You must complete at least one of the filter fields'
    }
  },
  report_management_page: {
    title_admin: {
      es: 'Administración de Reportes',
      en: 'Report Management'
    },
    title_user: {
      es: 'Reportes',
      en: 'Report'
    },
    actionsButtons: {
      new: {
        es: 'Nuevo Reporte',
        en: 'New Report'
      }
    },
    grid: {
      filter: {
        title: {
          es: 'Título de reporte',
          en: 'Report title'
        },
        description: {
          es: 'Descripción de reporte',
          en: 'Report description'
        }
      },
      columns: {
        number: {
          es: 'N°',
          en: 'N°'
        },
        title: {
          es: 'Titulo',
          en: 'Title'
        },
        type: {
          es: 'Tipo de reporte',
          en: 'Report type'
        },
        description: {
          es: 'Descripción de reporte',
          en: 'Report description'
        },
        created_date: {
          es: 'Fecha de Creación',
          en: 'Creation Date'
        },
        updated_date: {
          es: 'Fecha de Modificación',
          en: 'Modification Date'
        },
        actions: {
          es: 'Acciones',
          en: 'Actions'
        },
        view: {
          es: 'Ver',
          en: 'View'
        }
      },
      actions: {
        edit: {
          es: 'Editar',
          en: 'Edit'
        },
        delete: {
          es: 'Eliminar',
          en: 'Delete'
        }
      }
    }
  },
  modal_report: {
    title: {
      es: 'Registro de Reporte',
      en: 'Report Management'
    },
    actionsButtons: {},
    form: {
      id: {
        es: 'Id Reporte',
        en: 'Report Id'
      },
      code: {
        es: 'Code',
        en: 'Code'
      },
      title: {
        es: 'Título',
        en: 'Title'
      },
      type: {
        es: 'Tipo',
        en: 'Type'
      },
      description: {
        es: 'Descripción',
        en: 'Description'
      },
      all_permission: {
        es: 'Permiso total',
        en: 'All Permission'
      },
      organizations: {
        es: 'Organizaciones',
        en: 'Organizations'
      },
      link: {
        es: 'Enlace',
        en: 'Link'
      },
      update_hours: {
        es: 'Horas de actualización',
        en: 'Update Hours'
      },
      maintenance: {
        es: 'Mantenimiento',
        en: 'Maintenance'
      }
    },
    rules: {
      message_required: {
        es: 'Este campo es requerido',
        en: 'This field is required'
      }
    }
  },
  modal_delete_report: {
    message_confirmation: {
      es: '¿Estás seguro de que deseas eliminar este reporte?',
      en: 'Are you sure you want to delete this report?'
    }
  }
};
export default labels;